import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Logo from "../../../assets/images/Veeransh logo.png";

const FallbackSpinner = ({ height = "100vh" }) => {
  return (
    <Box
      sx={{
        height,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Box
        component="img"
        src={Logo}
        alt="Veeransh Logo"
        sx={{
          maxWidth: "260px",
          width: "100%",
          height: "auto",
          objectFit: "contain",
        }}
      />
      <CircularProgress disableShrink sx={{ mt: 6 }} />
    </Box>
  );
};

export default FallbackSpinner;
